import * as gs from "@ivanlog/gs";
import * as com from "../../plusx-lib/com/tmpls";
import { StatePaged } from "../../plusx-lib/states/abstracts/StatePaged";
import { StateDashboard } from "./StateDashboard";
import { Helper } from "../../plusx-lib/libs/Helper";

export class StateLoading extends StatePaged<com.PageLoadingShareX> {
    static readonly StateName = "loading" ;

    constructor() {
        super(com.PageLoadingShareX, "ShareX loading...", false);
    }

    public async start() {
        this._loadAsync();
        return super.start();
    }

    private async _loadAsync()
    {
        await Helper.awaitTime(200);
        await gs.StateGS.Run(StateDashboard);
    }
}